const API_URL = process.env.REACT_APP_API_URL;
const API_URLPublic = API_URL + "/public/";
const API_URLPublicArticles = API_URL + "/public/imagesarticles/";
const API_URLPublicCustomers = API_URL + "/public/customers/";

const Apis = {
  UserLoginAPI: `${API_URL}/api/root/login`,
  UserLoginEmployeAPI: `${API_URL}/api/root/employe/login`,
  api_updatecridentials: `${API_URL}/api/root/update/credentials`,

};
const ApiSupperSettings = {
  api_UsersAdmin: `${API_URL}/api/users/admin`,
  api_UsersAdmin_update: `${API_URL}/api/users/admin/`,
  api_Privilege: `${API_URL}/api/privileges/list`,
  api_Privilege_update: `${API_URL}/api/privileges/list/`,
  ///////////////////////////////////////////////////////////////////////////////////////////////
  api_ConfigApps: `${API_URL}/api/config/entity/`,


};

const ApiStandardUser = {
 

  api_Appointments: `${API_URL}/api/appointments/`,
  api_unavailabilities: `${API_URL}/api/unavailabilities/`,
  api_GeneralInfo: `${API_URL}/api/info/general`,

};

const ApiClient = {
  api_auth: `${API_URL}/api/clients/auth`,
  api_details: `${API_URL}/api/clients/details`,
  api_contact: `${API_URL}/api/clients/contact`,
};

export { API_URL, Apis, ApiSupperSettings, API_URLPublic, API_URLPublicArticles, API_URLPublicCustomers ,ApiStandardUser, ApiClient };